import CryptoJS from 'crypto-js';

const commentApiUrl =
    process.env.REACT_APP_COMMENT_API_URL || process.env.REACT_APP_API_URL;

export const fetchComments = async () => {
    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
    const startDate = oneYearAgo.toISOString();
    const endDate = new Date(today).toISOString();
    const response = await fetch(`${commentApiUrl}/api/comments?start_date=${startDate}&end_date=${endDate}`);
    const data = await response.json();
    return data;
};

export const postComment = async (commentData) => {
    const body = JSON.stringify(commentData);
    const hash = CryptoJS.SHA256(body).toString(CryptoJS.enc.Hex);

    const response = await fetch(`${commentApiUrl}/api/comments`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Amz-Content-Sha256': hash,
        },
        body: body,
    });
    const result = await response.json();

    // Return both the status code and the response body
    return {
        statusCode: response.status,
        body: JSON.stringify(result)
    };
};